/**
 * 进入页面的动作
 */
export const TRACKER_READY = 'TRACKER_READY'

/**
 * 路由变化的动作
 */
export const TRACKER_CHANGE = 'TRACKER_CHANGE'
